const levin_shop_money = document.querySelector('#levin_shop_money').getAttribute('content');
const levin_money_format = function (t, r) {
  function e(t, r) {
    return void 0 === t ? r : t;
  }
  function a(t, r, a, o) {
    if (((r = e(r, 2)), (a = e(a, ',')), (o = e(o, '.')), isNaN(t) || null == t)) return 0;
    t = (t / 100).toFixed(r);
    let n = t.split('.');
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + a) + (n[1] ? o + n[1] : '');
  }
  'string' == typeof t && (t = t.replace('.', ''));
  let o = '',
    n = /\{\{\s*(\w+)\s*\}\}/,
    i = r || this.money_format;
  switch (i.match(n)[1]) {
    case 'amount':
      o = a(t, 2);
      break;
    case 'amount_no_decimals':
      o = a(t, 0);
      break;
    case 'amount_with_comma_separator':
      o = a(t, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      o = a(t, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      o = a(t, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      o = a(t, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      o = a(t, 0, '.', '');
      break;
    case 'amount_with_space_separator':
      o = a(t, 2, ',', '');
      break;
    case 'amount_with_apostrophe_separator':
      o = a(t, 2, "'", '.');
  }
  return i.replace(n, o);
};

const getSectionsToRender = () => {
  return [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section',
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer').dataset.id,
      selector: '.js-contents',
    },
  ];
};

const getSectionInnerHTML = (html, selector) => {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};

const $update_cart_page = (cart_json) => {
  const $get_section_content_url =
    '/?sections=' +
    document.getElementById('main-cart-items').dataset.id +
    ',' +
    document.getElementById('main-cart-footer').dataset.id +
    ',cart-icon-bubble,cart-live-region-text';
  fetch($get_section_content_url, {
    method: 'GET',
  })
    .then((response) => response.json())
    .then((data) => {
      cart_json['sections'] = data;

      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(cart_json.sections[section.section], section.selector);
      });
      let locationId = null;
      let zipId = null;
      let locationStoreInfo = localStorage.getItem('filteredStoreInfo');
      if (locationStoreInfo === undefined || locationStoreInfo === null) {
        locationStoreInfo = {
          storepin: '15479',
          storelocationid: '6',
          storename: '<p class="storename-text">Smithton Distribution Center</p>',
          hours:
            '<span class="StoreSelectorListItem_storeHours_text">Opens</span>\n                at <span class="storeopen-time">10:00 AM</span>',
          distance: '<div class="storeinfo-distance-text">0 mi</div>',
          address: '301 Fitz Henry Road\nSmithton\nPennsylvania\n15479',
          links:
            '<div class="storeinfolinks-direction">\n                <svg class="storeinfolinks-direction-svg" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="NearMeIcon">\n                  <path d="M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98z"></path>\n                </svg>\n                <a href="https://www.google.com/maps/dir//%20301%20Fitz%20Henry%20Road%20Smithton,%20PA%2015479/@40.174286,-79.745834" alt="Smithton Distribution Center Directions" target="_blank" rel="noreferrer" id="store-info-expand-store-locator-slidout-directions-click-button">\n                  Directions\n                </a>\n              </div>\n              <a href="tel:18006001795" class="storeinfolinks-phone">18006001795</a>',
          opentime: '10:00 AM',
          visitstoreLink: 'https://87a1b5-d6.myshopify.com/pages/store-locator',
        };
      }
      if (locationStoreInfo !== undefined && locationStoreInfo !== null) {
        let MylocationData = locationStoreInfo;
        if (typeof locationStoreInfo == 'string') {
          MylocationData = JSON.parse(locationStoreInfo);
        }
        locationId = MylocationData.storelocationid;
        zipId = MylocationData.storepin;
      }
      if (document.querySelectorAll('.cartItem_protection_plan.is_checked')) {
        cartitem_checkbox_click_event();
      }

      const hasCartButtons_chk = document.querySelectorAll('[id^="covered_plans_btn_cart"]').length > 0;
      if (hasCartButtons_chk) {
        initializeProtectionButtons();
      }

      updatePrices();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

// This function reviews if the product has a compare-at-price property
function checkCompareProperty(element) {
  if (element && element.dataset) {
    return element.dataset.compare !== undefined;
  }
  return false;
}

// Replace prices in matching elements Start ...!
function updatePricesWithAPIData(RelatedPrice, locationId) {
  const priceData = RelatedPrice.data;
  if (priceData) {
    // Find all elements with the 'store_location_price' class
    const priceElements = document.querySelectorAll('.store_location_price');
    priceElements.forEach((priceElement) => {
      if (priceElement.closest('.product__info-container')?.querySelector('#custom-lineitem-id')) {
        document.getElementById('custom-lineitem-id').setAttribute('value', locationId);
      }
      return;

      //if (checkCompareProperty(priceElement)) return;
      const productId = priceElement.getAttribute('data-pid'); // Get the product ID from data-pid
      if (priceData[productId]?.currentSellingPrice) {
        const productPriceInfo = priceData[productId]; // Find matching price info
        if (productPriceInfo && productPriceInfo !== undefined) {
          if (priceElement.closest('.price__sale')) {
            const { currentSellingPrice } = productPriceInfo; // Get the current price
            const { standardSellingPrice } = productPriceInfo; // Get the current selling price
            const { msrp } = productPriceInfo; // Get the current selling price
            // Format the price: Remove ".00" for whole numbers
            const formattedPrice =
              currentSellingPrice % 1 === 0 ? currentSellingPrice.toFixed(0) : currentSellingPrice.toFixed(2);
            let formattedMSRPPrice = msrp % 1 === 0 ? msrp.toFixed(0) : msrp.toFixed(2);
            if (formattedMSRPPrice == 0) {
              formattedMSRPPrice =
                standardSellingPrice % 1 === 0 ? standardSellingPrice.toFixed(0) : standardSellingPrice.toFixed(2);
            }
            // Update the price in the element
            if (formattedMSRPPrice > formattedPrice) {
              priceElement.querySelector('s').textContent = `${levin_money_format(
                formattedMSRPPrice * 100,
                levin_shop_money,
              )}`;
              priceElement.setAttribute('data-pprice', formattedMSRPPrice); // Update the data-pprice attribute
            }

            if (formattedMSRPPrice == formattedPrice) {
              priceElement.classList.add('hidden');
            } else {
              priceElement.classList.remove('hidden');
            }

            const SavePrice = formattedMSRPPrice - formattedPrice;
            if (parseFloat(formattedMSRPPrice) > parseFloat(formattedPrice)) {
              const salePriceElement = priceElement.closest('.price__sale').querySelector('.store_location_saleprice');
              const PDP_main_price_cls = priceElement
                .closest('.price__sale')
                .querySelector('.store_location_saleprice.on_pdp');
              if (salePriceElement) {
                salePriceElement.textContent = '';
                const mainPrice = document.createTextNode(levin_money_format(formattedPrice * 100, levin_shop_money));
                salePriceElement.appendChild(mainPrice);
                if (__st && __st.p == 'product' && PDP_main_price_cls) {
                  const saveSpan = document.createElement('span');
                  saveSpan.textContent = ` You save ${levin_money_format(SavePrice * 100, levin_shop_money)}`;
                  salePriceElement.appendChild(saveSpan);
                }
              }
            } else {
              priceElement.closest('.price__sale').querySelector('.store_location_saleprice').textContent =
                `${levin_money_format(formattedPrice * 100, levin_shop_money)}`;
            }

            priceElement
              .closest('.price__sale')
              .querySelector('.store_location_saleprice')
              .setAttribute('data-pprice', formattedPrice);
            if (priceElement.closest('.product__info-container')) {
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-price')) {
                document.getElementById('custom-lineitem-price').setAttribute('value', formattedPrice);
              }
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-compare-price')) {
                document.getElementById('custom-lineitem-compare-price').setAttribute('value', formattedMSRPPrice);
              }
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-id')) {
                document.getElementById('custom-lineitem-id').setAttribute('value', locationId);
              }
            }
          } else {
            const { currentSellingPrice } = productPriceInfo; // Get the current price
            const { standardSellingPrice } = productPriceInfo; // Get the current selling price
            const { msrp } = productPriceInfo; // Get the current selling price
            // Format the price: Remove ".00" for whole numbers
            const formattedPrice =
              currentSellingPrice % 1 === 0 ? currentSellingPrice.toFixed(0) : currentSellingPrice.toFixed(2);
            let formattedMSRPPrice = msrp % 1 === 0 ? msrp.toFixed(0) : msrp.toFixed(2);
            if (formattedMSRPPrice === '0') {
              formattedMSRPPrice =
                standardSellingPrice % 1 === 0 ? standardSellingPrice.toFixed(0) : standardSellingPrice.toFixed(2);
            }
            // Update the price in the element
            priceElement.textContent = `${levin_money_format(formattedPrice * 100, levin_shop_money)}`;
            priceElement.setAttribute('data-pprice', formattedPrice); // Update the data-pprice attribute
            if (priceElement.closest('.product__info-container')) {
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-price')) {
                document.getElementById('custom-lineitem-price').setAttribute('value', formattedPrice);
              }
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-compare-price')) {
                document.getElementById('custom-lineitem-compare-price').setAttribute('value', formattedMSRPPrice);
              }
              if (priceElement.closest('.product__info-container').querySelector('#custom-lineitem-id')) {
                document.getElementById('custom-lineitem-id').setAttribute('value', locationId);
              }
            }
          }
        }
      }
    });
  } else {
    console.error('Price data not found in API response.');
  }
}
// Define the function to send the POST request
function sendLocationPriceRequest(productIds, locationId, zipId) {
  let RelatedPrice = [];
  const url = 'https://webmdlwr01.levinfurniture.com/api/location-price';
  const payload = {
    shop: Shopify.shop,
    skus: productIds,
    location_id: parseInt(locationId),
  };
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload), // Convert the payload to JSON string
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      RelatedPrice = data;
      if (RelatedPrice.data) {
        updatePricesWithAPIData(data, locationId);
      }
      // Process the response (example: update prices)
      if (data && data.status && data.data) {
        Object.entries(data.data).forEach(([productId, pricingDetails]) => {
          const priceDetail = pricingDetails[0]; // Assuming the first item has the price details
          if (priceDetail) {
            // Find the corresponding HTML element
            const priceElement = document.querySelector(`[data-pid="${productId}"]`);
            if (priceElement) {
              // Update the price on the page (customize formatting if needed)
              priceElement.textContent = levin_money_format(priceDetail.currentSellingPrice, levin_shop_money);
            }
          }
        });
      }
    })
    .catch((error) => console.error('Error:', error));
}

// Example usage: Call the function with product IDs and location ID
document.addEventListener('DOMContentLoaded', (event) => {
  const productIds = Array.from(
    new Set(Array.from(document.querySelectorAll('.store_location_price')).map((prod) => prod.dataset.pid)),
  ).filter((id) => typeof id === 'string' && id.trim() !== '');
  let locationId = null;
  let zipId = null;
  let locationStoreInfo = localStorage.getItem('filteredStoreInfo');
  if (locationStoreInfo === undefined || locationStoreInfo === null) {
    locationStoreInfo = {
      storepin: '15479',
      storelocationid: '6',
      storename: '<p class="storename-text">Smithton Distribution Center</p>',
      hours:
        '<span class="StoreSelectorListItem_storeHours_text">Opens</span>\n                at <span class="storeopen-time">10:00 AM</span>',
      distance: '<div class="storeinfo-distance-text">0 mi</div>',
      address: '301 Fitz Henry Road\nSmithton\nPennsylvania\n15479',
      links:
        '<div class="storeinfolinks-direction">\n                <svg class="storeinfolinks-direction-svg" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="NearMeIcon">\n                  <path d="M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98z"></path>\n                </svg>\n                <a href="https://www.google.com/maps/dir//%20301%20Fitz%20Henry%20Road%20Smithton,%20PA%2015479/@40.174286,-79.745834" alt="Smithton Distribution Center Directions" target="_blank" rel="noreferrer" id="store-info-expand-store-locator-slidout-directions-click-button">\n                  Directions\n                </a>\n              </div>\n              <a href="tel:18006001795" class="storeinfolinks-phone">18006001795</a>',
      opentime: '10:00 AM',
      visitstoreLink: 'https://87a1b5-d6.myshopify.com/pages/store-locator',
    };
  }
  if (locationStoreInfo !== undefined && locationStoreInfo !== null) {
    let MylocationData = locationStoreInfo;
    if (typeof locationStoreInfo == 'string') {
      MylocationData = JSON.parse(locationStoreInfo);
    }
    locationId = MylocationData.storelocationid;
    zipId = MylocationData.storepin;
  }
  if (locationId != null && zipId != null && productIds.length > 0) {
    sendLocationPriceRequest(productIds, locationId, zipId);
  }
});

function toggleStoreInfo(button) {
  var StoreSelectorListItem = button.closest('.StoreSelectorListItem_inn');
  var descriptionWrapper = StoreSelectorListItem.querySelector('.storeinfo-description-wrapp');
  if (StoreSelectorListItem.classList.contains('open-desc')) {
    StoreSelectorListItem.classList.remove('open-desc');
  } else {
    StoreSelectorListItem.classList.add('open-desc');
  }
}
let myStoreInertElements = [];
let myStoreFocusTrapHandler = null;
function trapMyStoreFocus() {
  releaseMyStoreFocus();
  // The header banner markup is rendered twice (desktop header + mobile menu drawer),
  // so target the popover instance that is actually visible in the current viewport.
  const popover = Array.from(document.querySelectorAll('.MyStoreLayover_container.show_mystore')).find(
    (el) => el.getClientRects().length > 0
  );
  if (!popover) return;
  let node = popover;
  while (node.parentElement && node !== document.body) {
    Array.from(node.parentElement.children).forEach((sibling) => {
      if (sibling === node) return;
      if (sibling.classList.contains('MyStoreLayoverOverlay')) return;
      if (sibling.hasAttribute('inert')) return;
      sibling.setAttribute('inert', '');
      myStoreInertElements.push(sibling);
    });
    node = node.parentElement;
  }
  const focusables = popover.querySelectorAll(
    "a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled"
  );
  if (focusables.length > 0) {
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    myStoreFocusTrapHandler = (event) => {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', myStoreFocusTrapHandler);
    requestAnimationFrame(() => first.focus());
  }
}
function releaseMyStoreFocus() {
  myStoreInertElements.forEach((el) => el.removeAttribute('inert'));
  myStoreInertElements = [];
  if (myStoreFocusTrapHandler) {
    document.removeEventListener('keydown', myStoreFocusTrapHandler);
    myStoreFocusTrapHandler = null;
  }
}
let locationDrawerFocusTrapHandler = null;
function trapLocationDrawerFocus() {
  releaseLocationDrawerFocus();
  const inner = document.querySelector('.location-drawer-wrapper.open-drawer .location-drawer-inner');
  if (!inner) return;
  // Results load asynchronously, so query focusables live on each Tab and wrap.
  locationDrawerFocusTrapHandler = (event) => {
    if (event.key !== 'Tab') return;
    const focusables = Array.from(
      inner.querySelectorAll(
        "a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled"
      )
    ).filter((el) => el.getClientRects().length > 0);
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };
  document.addEventListener('keydown', locationDrawerFocusTrapHandler);
  const initialFocus = inner.querySelector('.location-drawer-close') || inner;
  requestAnimationFrame(() => initialFocus.focus());
}
function releaseLocationDrawerFocus() {
  if (locationDrawerFocusTrapHandler) {
    document.removeEventListener('keydown', locationDrawerFocusTrapHandler);
    locationDrawerFocusTrapHandler = null;
  }
}
function locationDrawertoggle() {
  const savedHtml = localStorage.getItem('filteredStoreInfo');
  if (savedHtml == null || savedHtml == 'undefined') {
    const LocationDrawer = document.querySelector('.location-drawer-wrapper');
    if (LocationDrawer.classList.contains('open-drawer')) {
      LocationDrawer.classList.remove('open-drawer');
      releaseLocationDrawerFocus();
    } else {
      LocationDrawer.classList.add('open-drawer');
      trapLocationDrawerFocus();
    }
  } else {
    document
      .querySelectorAll('.MyStoreLayover_container')
      .forEach((el) => el.classList.toggle('show_mystore'));
    if (document.querySelector('.MyStoreLayover_container.show_mystore')) {
      trapMyStoreFocus();
    } else {
      releaseMyStoreFocus();
    }
  }
}
function closeHamburgerIfOpen() {
  const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (menuDrawerDetails && menuDrawerDetails.hasAttribute('open')) {
    const summary = menuDrawerDetails.querySelector('summary');
    if (summary) summary.click();
  }
}
function closeMyStoreModals() {
  document
    .querySelectorAll('.MyStoreLayover_container')
    .forEach((el) => el.classList.remove('show_mystore'));
  releaseMyStoreFocus();
}
function closeShowMystore() {
  closeMyStoreModals();
  closeHamburgerIfOpen();
}
document.addEventListener('DOMContentLoaded', () => {
  const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!menuDrawerDetails) return;
  menuDrawerDetails.addEventListener('toggle', () => {
    if (!menuDrawerDetails.open) closeMyStoreModals();
  });
});
function locationDrawerhide() {
  document.querySelector('.location-drawer-wrapper').classList.remove('open-drawer');
  releaseLocationDrawerFocus();
  closeMyStoreModals();
  closeHamburgerIfOpen();
}
function updateStoreOpenTime(storeListSelector) {
  storeListSelector.forEach((item) => {
    const activeTimeElement = item.querySelector('.storehoures-info-time .storehoures-info.active');
    if (activeTimeElement) {
      const activeTime = activeTimeElement.innerText;
      const timeParts = activeTime.split(' - ');
      const startTime = timeParts[0];
      const closeTime = timeParts[1] || '';
      const storeOpenTimeElement = item.querySelector('.storeopen-time');
      if (storeOpenTimeElement) {
        storeOpenTimeElement.innerText = startTime;
      }
      let storeCloseTimeElement = item.querySelector('.storeclose-time');
      if (!storeCloseTimeElement) {
        storeCloseTimeElement = document.createElement('span');
        storeCloseTimeElement.className = 'storeclose-time';
        storeCloseTimeElement.style.display = 'none';
        item.appendChild(storeCloseTimeElement);
      }
      storeCloseTimeElement.innerText = closeTime;
    }
  });
}
//this is invoked when user clicks on the change store btn once the modal is open
async function locationDrawershow(btn) {
  var Datapin = btn.dataset.pin;
  var Datahead = btn.dataset.head;
  var Datamile = btn.dataset.mile.replace(' miles', '');
  document.querySelector('.location-search-input').value = Datapin;
  document.querySelector('.location-drawer-wrapper').classList.add('open-drawer');
  document.querySelectorAll('.MyStoreLayover_container').forEach((el) => el.classList.remove('show_mystore'));
  releaseMyStoreFocus();
  trapLocationDrawerFocus();
  await document
    .querySelector('.location-drawer-resultwrapp')
    .querySelector('.location-drawer-loader')
    .classList.add('loading-widget');
  await filterAndMoveElements(Datapin, Datahead, Datamile);
  var StoreSelectorListItemInn = document
    .querySelector('.location-drawer-inner')
    .querySelectorAll('.StoreSelectorListItem_inn');
  await updateStoreOpenTime(StoreSelectorListItemInn);
}
async function filterAndMoveElements(matchPin, matchhead, Datamile) {
  await document
    .querySelector('.location-drawer-resultwrapp')
    .querySelector('.location-drawer-loader')
    .classList.add('loading-widget');
  const getItems = document.getElementById('StoreSelectorListItem_wrapper');
  const items = getItems.querySelectorAll('.StoreSelectorListItem_inn');
  const targetDiv = document.getElementById('location-drawer-result').querySelector('.StoreSelectorListItem_wrapper');
  targetDiv.innerHTML = '';
  const apiKey = 'js-ej58XknjxlVQ2wgbMfONxLuI7o8vJQn3Vs95k8tW2nAMT4CWhD9ryh69v0fGLnel';
  let radius = 50; // Default value
  if (Datamile !== undefined && Datamile !== null) {
    radius = Datamile; // Override if valid
  }
  const units = 'mile';
  const apiUrl = `https://www.zipcodeapi.com/rest/${apiKey}/radius.json/${matchPin}/${radius}/${units}`;
  await fetch(apiUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      const parsedData = data; // Parse the wrapped response
      let $distance_array = [];
      if (parsedData && parsedData?.zip_codes) {
        parsedData.zip_codes.forEach((Zip) => {
          items.forEach((item) => {
            if (item.dataset.pin === Zip.zip_code) {
              var ZipDistance = Zip.distance + ' mi';
              $distance_array.push(Zip.distance);
              item.setAttribute('data-distance', Zip.distance);
              const clonedItem = item.cloneNode(true);
              clonedItem.querySelector('.storeinfo-distance-text').innerText = ZipDistance;
              targetDiv.appendChild(clonedItem);
              var today = new Date();
              var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var currentDay = dayNames[today.getDay()];
              var dayElements = document.querySelectorAll('.storehoures-info[data-day]');
              dayElements.forEach((element) => {
                if (element.getAttribute('data-day') === currentDay) {
                  element.classList.add('active');
                } else {
                  element.classList.remove('active');
                }
              });
              var StoreSelectorListItemInn = document
                .querySelector('.location-drawer-inner')
                .querySelectorAll('.StoreSelectorListItem_inn');
              updateStoreOpenTime(StoreSelectorListItemInn);
            }
          });
        });
      }
      if ($distance_array.length > 0) {
        $distance_array.sort((x, y) => Math.abs(x) - Math.abs(y));
        const $wrapperEl = document
          .getElementById('location-drawer-result')
          .querySelector('.StoreSelectorListItem_wrapper');
        $wrapperEl.querySelectorAll('.StoreSelectorListItem_inn').forEach((item) => {
          const $distance_val = item.getAttribute('data-distance');
          const $matching_idx = $distance_array.indexOf(parseFloat($distance_val));
          if ($matching_idx > -1) {
            item.setAttribute('data-sortorder', $matching_idx);
          }
        });
        // Re-append the nodes in distance order so DOM order matches the visual
        // (CSS `order`) order. Keyboard focus and screen-reader reading order
        // follow DOM order, so without this they'd hit stores in the wrong order.
        Array.from($wrapperEl.querySelectorAll('.StoreSelectorListItem_inn'))
          .sort((a, b) => parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance))
          .forEach((item) => $wrapperEl.appendChild(item));
      }
    })
    .catch((error) => console.error('Error:', error));
  var CountResult = await targetDiv.querySelectorAll('.StoreSelectorListItem_inn').length;
  if (CountResult > 0) {
    document.querySelector('.location-drawer-noresult-wrapp').classList.add('hide-noresult');
  } else {
    document.querySelector('.location-drawer-noresult-wrapp').classList.remove('hide-noresult');
  }
  if (matchhead) {
    document
      .querySelector('.location-drawer-resultwrapp')
      .querySelectorAll('.StoreSelectorListItem_inn')
      .forEach((item) => {
        var ItemHead = item.querySelector('.storename-text').textContent;
        if (ItemHead == matchhead) {
          item.classList.add('set_Mystore');
        }
      });
  }
  await document
    .querySelector('.location-drawer-resultwrapp')
    .querySelector('.location-drawer-loader')
    .classList.remove('loading-widget');

  var drawerStores = targetDiv.querySelectorAll('.StoreSelectorListItem_inn');
  var closestStores = Array.from(drawerStores)
    .sort((a, b) => parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance))
    .map((store) => ({
      locationId: store.dataset.lcid,
      name: store.querySelector('.storename-text')?.textContent || '',
      pin: store.dataset.pin,
      distance: store.dataset.distance + ' mi',
      visitLink: store.querySelector('.button-visit-store')?.getAttribute('href') || '',
      opentime: store.querySelector('.storeopen-time')?.textContent || '',
      closetime: store.querySelector('.storeclose-time')?.textContent || '',
    }));
  try {
    localStorage.setItem('closestStores', JSON.stringify(closestStores));
    localStorage.setItem('activeZip', matchPin);
  } catch (e) {
    // localStorage unavailable or full
  }
  document.dispatchEvent(new Event('closestStoresReady'));
}
  //end test
function filterLocation(btn) {
  var InputLength = document.querySelector('.location-search-input').value.trim();
  if (InputLength.length < 5) {
    document.querySelector('.location-drawer-form-inn').classList.add('show-error');
  } else {
    document.querySelector('.location-drawer-form-inn').classList.remove('show-error');
    filterAndMoveElements(InputLength);
  }
}
function setdefaultData(btn) {
  var storeIteminn = btn.closest('.StoreSelectorListItem_wrapper').querySelectorAll('.StoreSelectorListItem_inn');
  storeIteminn.forEach((element) => {
    element.classList.remove('set_Mystore');
  });
  var storeItem = btn.closest('.StoreSelectorListItem_inn');
  storeItem.classList.add('set_Mystore');
  var storepin = storeItem.dataset.pin;
  var storelocationid = storeItem.dataset.lcid;
  var storename = storeItem.querySelector('.storeinfo-storename')?.innerHTML.trim() || '';
  var storenameTmp = document.createElement('div');
  storenameTmp.innerHTML = storename;
  var datastoreName = storenameTmp.textContent.trim();
  var hours = storeItem.querySelector('.StoreSelectorListItem_storeHoursContainer')?.innerHTML.trim() || '';
  var distance = storeItem.querySelector('.storeinfo-distance-wrapp')?.innerHTML.trim() || '';
  var address = storeItem.querySelector('.storeinfo-address')?.innerHTML.trim() || '';
  var links = storeItem.querySelector('.storeinfolinks-wrapp')?.innerHTML.trim() || '';
  var opentime = storeItem.querySelector('.storeopen-time')?.innerHTML.trim() || '';
  var visitstoreLink = storeItem.querySelector('.button-visit-store')?.getAttribute('href') || '';
  var filteredStoreInfo = {
    storepin,
    storelocationid,
    storename,
    hours,
    distance,
    address,
    links,
    opentime,
    visitstoreLink,
  };
  localStorage.setItem('filteredStoreInfo', JSON.stringify(filteredStoreInfo));

  var drawerStores = btn.closest('.StoreSelectorListItem_wrapper').querySelectorAll('.StoreSelectorListItem_inn');
  var closestStores = Array.from(drawerStores)
    .sort((a, b) => parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance))
    .map((store) => ({
      locationId: store.dataset.lcid,
      name: store.querySelector('.storename-text')?.textContent || '',
      pin: store.dataset.pin,
      distance: store.dataset.distance + ' mi',
      visitLink: store.querySelector('.button-visit-store')?.getAttribute('href') || '',
      opentime: store.querySelector('.storeopen-time')?.textContent || '',
      closetime: store.querySelector('.storeclose-time')?.textContent || '',
    }));
  try {
    localStorage.setItem('closestStores', JSON.stringify(closestStores));
    localStorage.setItem('activeZip', storepin);
  } catch (e) {
    // localStorage unavailable or full
  }
  document.dispatchEvent(new Event('closestStoresReady'));

  if (window.location.pathname === '/cart') {
    window.location.reload();
  }
  var PopLocation = document.querySelector('.MyStoreLayover_contentWrapper');
  var PopLocationHead = PopLocation.querySelector('.storeinfo-storename');
  var PopLocationHour = PopLocation.querySelector('.StoreSelectorListItem_storeHoursContainer');
  var PopLocationDistance = PopLocation.querySelector('.storeinfo-distance-wrapp');
  var PopLocationAddress = PopLocation.querySelector('.storeinfo-address');
  var PopLocationLink = PopLocation.querySelector('.storeinfolinks-wrapp');
  var PopLocationopentime = PopLocation.querySelector('.storeopen-time');
  var PopLocationVisitUrl = PopLocation.querySelector('.MyStoreLayover_storeInfoLinks_text');
  var changelocationBtns = document.querySelectorAll('#change-store-store-locator-modal');
  PopLocationHead.innerHTML = storename;
  PopLocationHour.innerHTML = hours;
  PopLocationDistance.innerHTML = distance;
  PopLocationAddress.innerHTML = address;
  PopLocationLink.innerHTML = links;
  PopLocationopentime.innerHTML = opentime;
  PopLocationVisitUrl.setAttribute('href', visitstoreLink);
  if (document.querySelector('.selected_title')) {
    var Milescont = document.querySelector('.selected_title').textContent;
  } else {
    var Milescont = '50 miles';
  }
  changelocationBtns.forEach((btn) => {
    btn.setAttribute('data-pin', storepin);
    btn.setAttribute('data-mile', Milescont);
    btn.setAttribute('data-head', datastoreName);
  });
  document.querySelector('.location-drawer-wrapper').classList.remove('open-drawer');
  releaseLocationDrawerFocus();
  closeMyStoreModals();
  closeHamburgerIfOpen();
  document.querySelectorAll('.open-drawer-labelbtn').forEach((cont) => {
    cont.querySelector('span').innerText = 'Store : ' + datastoreName;
  });
  updateShowroomContent(Milescont);
  const changeproductIds = Array.from(
    new Set(Array.from(document.querySelectorAll('.delivery-atcp')).map((prod) => prod.dataset.pid)),
  ).filter((id) => typeof id === 'string' && id.trim() !== '');
  if (document.querySelector('.delivery-options-main') && changeproductIds.length > 0) {
    DeleveryRequest(changeproductIds, storelocationid, storepin);
  }
  const productIds = Array.from(
    new Set(Array.from(document.querySelectorAll('.store_location_price')).map((prod) => prod.dataset.pid)),
  ).filter((id) => typeof id === 'string' && id.trim() !== '');
  if (productIds.length > 0) {
    sendLocationPriceRequest(productIds, storelocationid, storepin);
  }
}
function handleKeyDown(event) {
  if (event.key === 'Enter') {
    filterLocation();
  }
}
//This is the btn: Use Current Location
//Re-detects where the user actually is on every click (GPS -> reverse geocode, IP fallback)
//instead of replaying the zip cached in localStorage from a previous visit.
//Unlike detectUserLocation() this only refills the drawer list, it does not auto-pick a store,
//since the user is standing in the drawer to choose one themselves.
async function Getipzip(btn) {
  const loader = document.querySelector('.location-drawer-resultwrapp')?.querySelector('.location-drawer-loader');
  if (btn) {
    // Geolocation can take a few seconds, so block repeat clicks from stacking lookups
    if (btn.disabled) {
      return;
    }
    btn.disabled = true;
  }
  // filterAndMoveElements() raises the loader too, but only after we already know the
  // zip, so raise it here to cover the detection wait as well
  loader?.classList.add('loading-widget');
  try {
    const zipcode = await resolveCurrentZip();
    document.querySelector('.location-search-input').value = zipcode;
    await filterAndMoveElements(zipcode);
  } finally {
    loader?.classList.remove('loading-widget');
    if (btn) {
      btn.disabled = false;
    }
  }
}
async function updateShowroomContent(Milescont) {
  const showroomContent = document.querySelector('.visit_showroom_content');
  if (!showroomContent) {
    return;
  }
  await showroomContent.classList.add('loading');
  const ProductfilteredStoreInfo = localStorage.getItem('filteredStoreInfo');
  let CountResultpin = 0;
  if (ProductfilteredStoreInfo) {
    const MystoreDataProduct = JSON.parse(ProductfilteredStoreInfo);
    const ProductdatastorePin = MystoreDataProduct.storepin;
    const productStorenameTmp = document.createElement('div');
    productStorenameTmp.innerHTML = MystoreDataProduct.storename || '';
    const Productdatastorename = productStorenameTmp.textContent.trim();
    showroomContent.querySelector('.current_storelac_pin').innerText = ProductdatastorePin;
    showroomContent.querySelector('.current_storelac_pin').setAttribute('data-pin', ProductdatastorePin);
    showroomContent.querySelector('.current_storelac_pin').setAttribute('data-mile', Milescont);
    showroomContent.querySelector('.current_storelac_pin').setAttribute('data-head', Productdatastorename);
    const apiKey = 'js-ej58XknjxlVQ2wgbMfONxLuI7o8vJQn3Vs95k8tW2nAMT4CWhD9ryh69v0fGLnel';
    const radiusText = Milescont.replace(' miles', '');
    const radius = parseInt(radiusText, 10) || 0;
    const units = 'mile';
    const apiUrl = `https://www.zipcodeapi.com/rest/${apiKey}/radius.json/${ProductdatastorePin}/${radius}/${units}`;
    await fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const parsedData = data; // Parse the wrapped response
        const CgetItems = document.getElementById('StoreSelectorListItem_wrapper');
        if (CgetItems) {
          const citems = CgetItems.querySelectorAll('.StoreSelectorListItem_inn');
          if (parsedData && parsedData?.zip_codes) {
            parsedData.zip_codes.forEach((Zip) => {
              citems.forEach((item) => {
                if (item.dataset.pin === Zip.zip_code) {
                  CountResultpin++;
                }
              });
            });
          }
        }
        showroomContent.querySelector('.counter_text').innerHTML = `There are ${CountResultpin} stores within `;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  await showroomContent.classList.remove('loading');
}

const $get_nearest_location = async ($location_zipcode) => {
  await document
    .querySelector('.location-drawer-resultwrapp')
    .querySelector('.location-drawer-loader')
    .classList.add('loading-widget');
  const getItems = document.getElementById('StoreSelectorListItem_wrapper');
  const items = getItems.querySelectorAll('.StoreSelectorListItem_inn');
  const targetDiv = document.getElementById('location-drawer-result').querySelector('.StoreSelectorListItem_wrapper');
  targetDiv.innerHTML = '';
  const apiKey = 'js-ej58XknjxlVQ2wgbMfONxLuI7o8vJQn3Vs95k8tW2nAMT4CWhD9ryh69v0fGLnel';
  const radius = 50;
  const units = 'mile';
  const apiUrl = `https://www.zipcodeapi.com/rest/${apiKey}/radius.json/${$location_zipcode}/${radius}/${units}`;
  await fetch(apiUrl)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      const parsedData = data; // Parse the wrapped response
      let $distance_array = [];
      if (parsedData && parsedData?.zip_codes) {
        parsedData.zip_codes.forEach((Zip) => {
          items.forEach((item) => {
            if (item.dataset.pin === Zip.zip_code) {
              var ZipDistance = Zip.distance + ' mi';
              $distance_array.push(Zip.distance);
              item.setAttribute('data-distance', Zip.distance);
              const clonedItem = item.cloneNode(true);
              clonedItem.querySelector('.storeinfo-distance-text').innerText = ZipDistance;
              targetDiv.appendChild(clonedItem);
              var today = new Date();
              var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var currentDay = dayNames[today.getDay()];
              var dayElements = document.querySelectorAll('.storehoures-info[data-day]');
              dayElements.forEach((element) => {
                if (element.getAttribute('data-day') === currentDay) {
                  element.classList.add('active');
                } else {
                  element.classList.remove('active');
                }
              });
              var StoreSelectorListItemInn = document
                .querySelector('.location-drawer-inner')
                .querySelectorAll('.StoreSelectorListItem_inn');
              updateStoreOpenTime(StoreSelectorListItemInn);
            }
          });
        });
      }
      if ($distance_array.length > 0) {
        $distance_array.sort((x, y) => Math.abs(x) - Math.abs(y));
        document
          .getElementById('location-drawer-result')
          .querySelector('.StoreSelectorListItem_wrapper')
          .querySelectorAll('.StoreSelectorListItem_inn')
          .forEach((item) => {
            const $distance_val = item.getAttribute('data-distance');
            const $matching_idx = $distance_array.indexOf(parseFloat($distance_val));
            if ($matching_idx > -1) {
              item.setAttribute('data-sortorder', $matching_idx);
            }
          });
        document
          .getElementById('location-drawer-result')
          .querySelector('.StoreSelectorListItem_wrapper')
          .querySelector('.StoreSelectorListItem_inn[data-sortorder="0"] .button-set-default-store')
          .click();
      } else {
        document
          .getElementById('location-drawer-result')
          .querySelector('.StoreSelectorListItem_wrapper')
          .querySelector('.StoreSelectorListItem_inn[data-lcid="6"] .button-set-default-store')
          .click();
      }
    })
    .catch((error) => {
      document
        .getElementById('StoreSelectorListItem_wrapper')
        .querySelector('.StoreSelectorListItem_inn[data-lcid="6"] .button-set-default-store')
        .click();
      console.error('Error:', error);
    });
};

const $set_default_location = async ($location_zipcode) => {
  document.querySelector('.location-search-input').value = $location_zipcode;
  await $get_nearest_location($location_zipcode);
};

//Geolocation for zipcode location methods:
//Last-resort store zip (Smithton) when we have no consented location for the user.
const FALLBACK_ZIP = '15479';

//Caches a freshly detected zip so later visits can skip the whole lookup.
function storeCurrentZip(zipcode) {
  localStorage.setItem('CurrentZipLocation', zipcode);
  //this localStorage flag is used to prevent the prompt in the future as we already have the location data.
  localStorage.setItem('locationPermissionAsked', 'true');
  return zipcode;
}

//get zipcode via IP. Only reached AFTER the user has granted geolocation consent and the
//reverse geocode itself failed — never after a denial, which is the CIPA exposure.
//Resolves to null (not the fallback zip) when the lookup fails, so the caller can decide.
function resolveZipFromIPaddress() {
  return fetch('https://api.ipgeolocation.io/ipgeo?apiKey=6115c35be4cd461486e1d3e187a33b75')
    .then((response) => response.json())
    .then((obj) => obj.zipcode || null)
    .catch(() => null);
}

//Geolocation based on user permission, this is the most accurate way to get user's location as it uses GPS coordinates.
//Always asks the browser for a fresh fix — it never reads the cached CurrentZipLocation —
//and resolves with the zip so callers can decide what to do with it.
function resolveCurrentZip() {
  const geoZip = navigator.geolocation
    ? new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            //ok so now the user allowed to use their location
            //Call a reverse geocoding API to get the zip code from latitude and longitude in this case, I am using BigDataCloud's Reverse Geocoding API which is free and doesn't require an API key
            fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
            )
              .then((response) => response.json())
              .then((data) => {
                // use zipcode in the existing flow
                // Consent was granted, so an IP fallback is fine when the geocode has no postcode
                resolve(data.postcode || resolveZipFromIPaddress());
              })
              .catch((err) => {
                console.error('Error fetching zip code:', err);
                // BigDataCloud failed, but the user did consent, so fall back to IP
                resolve(resolveZipFromIPaddress());
              });
          },
          () => {
            // User denied location (or the fix timed out). We deliberately do NOT fall back to
            // an IP lookup — deriving location after a denial is a CIPA exposure in some states.
            console.log('users denied location access, defaulting to Smithton');
            resolve(null);
          },
          // Without a timeout a hung fix leaves the drawer spinning forever;
          // maximumAge 0 keeps this an actual re-detect rather than a replayed fix.
          { timeout: 10000, maximumAge: 0 },
        );
      })
    : Promise.resolve(null);

  //Only cache a real detection. The fallback zip is never written to CurrentZipLocation.
  //Getipzip() calls this resolver directly, so the drawer's re-detect button always asks the browser again.
  return geoZip.then((zipcode) => (zipcode ? storeCurrentZip(zipcode) : FALLBACK_ZIP));
}

//Page-load entry point: detect, then pick the nearest store as the default.
function detectUserLocation() {
  resolveCurrentZip().then((zipcode) => {
    //Mark the prompt as asked even when we ended up on the fallback zip. If the user blocked
    //location (or the fix timed out) and this flag stays unset, every page load re-runs
    //detection, and because setdefaultData() reloads /cart after auto-picking a store, the
    //cart page reloads forever. The drawer's re-detect button is the explicit retry path.
    localStorage.setItem('locationPermissionAsked', 'true');
    return $set_default_location(zipcode);
  });
}

function onDomLoadloc() {
  const filteredStoreInfo = localStorage.getItem('filteredStoreInfo');
  if (filteredStoreInfo) {
    const MystoreData = JSON.parse(filteredStoreInfo);
    const datastorePin = MystoreData.storepin;

    if (!localStorage.getItem('closestStores')) {
      $get_nearest_location(datastorePin);
    }
    const storenameTmp = document.createElement('div');
    storenameTmp.innerHTML = MystoreData.storename || '';
    const datastoreName = storenameTmp.textContent.trim();
    const storeName = MystoreData.storename;
    const storeHours = MystoreData.hours;
    const storeDistance = MystoreData.distance;
    const storeAddress = MystoreData.address;
    const directionsLink = MystoreData.links;
    const storeOpentime = MystoreData.opentime;
    const storeVisitLink = MystoreData.visitstoreLink;
    const PopLocation = document.querySelector('.MyStoreLayover_contentWrapper');
    const PopLocationHead = PopLocation.querySelector('.storeinfo-storename');
    const PopLocationHour = PopLocation.querySelector('.StoreSelectorListItem_storeHoursContainer');
    const PopLocationDistance = PopLocation.querySelector('.storeinfo-distance-wrapp');
    const PopLocationAddress = PopLocation.querySelector('.storeinfo-address');
    const PopLocationLink = PopLocation.querySelector('.storeinfolinks-wrapp');
    const PopLocationopentime = PopLocation.querySelector('.storeopen-time');
    const PopLocationVisitUrl = PopLocation.querySelector('.MyStoreLayover_storeInfoLinks_text');
    const changelocationBtns = document.querySelectorAll('#change-store-store-locator-modal');
    PopLocationHead.innerHTML = storeName;
    PopLocationHour.innerHTML = storeHours;
    PopLocationDistance.innerHTML = storeDistance;
    PopLocationAddress.innerHTML = storeAddress;
    PopLocationLink.innerHTML = directionsLink;
    PopLocationopentime.textContent = String(storeOpentime || '').trim();
    PopLocationVisitUrl.setAttribute('href', storeVisitLink);
    changelocationBtns.forEach((btn) => {
      btn.setAttribute('data-pin', datastorePin);
      btn.setAttribute('data-mile', '50 miles');
      btn.setAttribute('data-head', datastoreName);
    });
    document.querySelectorAll('.open-drawer-labelbtn').forEach((cont) => {
      cont.querySelector('span').innerText = 'Store : ' + datastoreName;
    });
  }

  //after the DOM as loaded we make the check to grab user zipcode
  if (!localStorage.getItem('locationPermissionAsked') && navigator.geolocation) {
    detectUserLocation();
  }

  var Milescont = '50 miles';
  updateShowroomContent(Milescont);
}
document.addEventListener('DOMContentLoaded', onDomLoadloc);
if (document.querySelector('.select-box')) {
  document.querySelector('.select-box').addEventListener('click', function () {
    this.classList.toggle('active');
    document.querySelector('.options').classList.toggle('show');
  });
}
document.querySelectorAll('.option').forEach((option) => {
  option.addEventListener('click', function () {
    var Milescont = this.textContent;
    document.querySelector('.selected_title').textContent = Milescont;
    document.querySelector('.current_storelac_pin').setAttribute('data-mile', Milescont);
    document.querySelector('.select-box').classList.remove('active');
    document.querySelector('.options').classList.remove('show');
    updateShowroomContent(Milescont);
  });
});

/* -- Start EstimationTime ?? Used on the PDP -- */
function formatDate(dateString) {
  const date = new Date(dateString);
  // Get day of the week and month names
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  // Format the date
  return date.toLocaleDateString('en-US', options);
}

// Replace prices in matching elements
function EstimatedateWithAPIData(RelatedPrice) {
  const EstimateData = RelatedPrice.data;
  let ATC = null;
  let ATCPrice = 0;
  let ATP = null;
  let AtcDate = null;
  let AtpDate = null;
  let sessionDatavalues = [];
  if (EstimateData.availabilities[0] !== undefined) {
    let ProductSKUID = EstimateData.availabilities[0].storisProductId;
    document.querySelector('.delivery-atcp .delivery-options-wrapper').style.display = 'block';
    if (EstimateData.availabilities[0].availableDateAndRouteCodes == null) {
      document.querySelector('.delivery-atcp .delivery-options-atc').style.display = 'none';
    } else {
      document.querySelector('.delivery-atcp .delivery-options-atc').style.display = 'flex';
      ATC = EstimateData.availabilities[0].availableDateAndRouteCodes[0].availableDate;
      ATCPrice = EstimateData.availabilities[0].deliveryCharge;
      AtcDate = formatDate(ATC);
      document.querySelector('.delivery-atcp .delivery-options-atc .estimate-price .subtext').innerText = AtcDate;
      sessionDatavalues.push({ key: 'In Home', value: ATC.split('T0')[0] });
    }
    if (EstimateData.availabilities[0].availableDateAndRouteCodes == null) {
      document.querySelector('.delivery-atcp .delivery-options-atp').style.display = 'none';
    } else {
      document.querySelector('.delivery-atcp .delivery-options-atp').style.display = 'flex';
      ATP = EstimateData.availabilities[0].atpDate;
      AtpDate = formatDate(ATP);
      document.querySelector('.delivery-atcp .delivery-options-atp .delivery-options-text .subtext').innerText =
        AtpDate;
      sessionDatavalues.push({ key: 'Pick Up', value: ATP.split('T0')[0] });
    }
    if (AtcDate == null && AtpDate == null) {
      document.querySelector('.delivery-atcp .delivery-options-wrapper').style.display = 'none';
    }
    if (AtcDate != null || AtpDate != null) {
      sessionStorage.setItem(ProductSKUID, JSON.stringify(sessionDatavalues));
    }
  } else {
    document.querySelector('.delivery-atcp .delivery-options-wrapper').style.display = 'none';
  }
}
// Define the function to send the POST request

function DeleveryRequest(productIds, locationId, zipId) {
  // The API endpoint
  const url = 'https://webmdlwr01.levinfurniture.com/api/available-dates';
  const payload = {
    shop: Shopify.shop,
    location_id: locationId,
    zip: zipId,
    skus: productIds,
  };
  // POST request using fetch
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload), // Convert the payload to JSON string
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      RelatedPrice = data;
      if (RelatedPrice.data) {
        EstimatedateWithAPIData(data);
      }
    })
    .catch((error) => console.error('Error:', error));
}

const $get_new_atc_date = async ($this_sku, $selected_pickup_location, $selected_pincode, $this_item) => {
  const payload = {
    shop: Shopify.shop,
    location_id: $selected_pickup_location,
    zip: $selected_pincode,
    skus: $this_sku,
  };
  fetch('https://webmdlwr01.levinfurniture.com/api/available-dates', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      RelatedPrice = data;
      if (RelatedPrice.data) {
        if (
          RelatedPrice.data.availabilities[0].atpDate != null &&
          RelatedPrice.data.availabilities[0].atpDate != undefined &&
          RelatedPrice.data.availabilities[0].atpDate != ''
        ) {
          $this_item.querySelector('.inhome-pickup .dateselect').innerHTML =
            RelatedPrice.data.availabilities[0].atpDate.split('T0')[0];
          $change_pickup_date_in_lineitem($this_item, RelatedPrice.data.availabilities[0].atpDate.split('T0')[0]);
        }
      }
    })
    .catch((error) => console.error('Error:', error));
};

// Example usage: Call the function with product IDs and location ID
document.addEventListener('DOMContentLoaded', (event) => {
  const productIds = Array.from(
    new Set(Array.from(document.querySelectorAll('.delivery-atcp')).map((prod) => prod.dataset.pid)),
  ).filter((id) => typeof id === 'string' && id.trim() !== '');

  let locationId = null;
  let zipId = null;
  let locationStoreInfo = localStorage.getItem('filteredStoreInfo');
  if (locationStoreInfo === undefined || locationStoreInfo === null) {
    locationStoreInfo = {
      storepin: '15479',
      storelocationid: '6',
      storename: '<p class="storename-text">Smithton Distribution Center</p>',
      hours:
        '<span class="StoreSelectorListItem_storeHours_text">Opens</span>\n                at <span class="storeopen-time">10:00 AM</span>',
      distance: '<div class="storeinfo-distance-text">0 mi</div>',
      address: '301 Fitz Henry Road\nSmithton\nPennsylvania\n15479',
      links:
        '<div class="storeinfolinks-direction">\n                <svg class="storeinfolinks-direction-svg" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="NearMeIcon">\n                  <path d="M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98z"></path>\n                </svg>\n                <a href="https://www.google.com/maps/dir//%20301%20Fitz%20Henry%20Road%20Smithton,%20PA%2015479/@40.174286,-79.745834" alt="Smithton Distribution Center Directions" target="_blank" rel="noreferrer" id="store-info-expand-store-locator-slidout-directions-click-button">\n                  Directions\n                </a>\n              </div>\n              <a href="tel:18006001795" class="storeinfolinks-phone">18006001795</a>',
      opentime: '10:00 AM',
      visitstoreLink: 'https://87a1b5-d6.myshopify.com/pages/store-locator',
    };
  }
  if (locationStoreInfo !== undefined && locationStoreInfo !== null) {
    let MylocationData = locationStoreInfo;
    if (typeof locationStoreInfo == 'string') {
      MylocationData = JSON.parse(locationStoreInfo);
    }
    locationId = MylocationData.storelocationid;
    zipId = MylocationData.storepin;
    document.querySelectorAll('.delevery_option_widget').forEach((widget) => {
      widget.style.display = 'block';
    });
  } else {
    document.querySelectorAll('.select_store_location').forEach((widget) => {
      widget.style.display = 'block';
    });
  }
  if (document.querySelector('.delivery-options-main') && productIds.length > 0) {
    DeleveryRequest(productIds, locationId, zipId);
  }
});

async function fetchEligiblePins() {
  console.log('▶️ Entering fetchEligiblePins()');

  const tokenMap = {
    127: '3c518870ab383ace774fb178478063c6',
    'levinfurniture.com': '5a78e3bd800d5d9added0527896d4b8d',
    'johnvschultz.com': '3ee2a62a408262ddd09f6f88a088216c',
  };

  const urlKey = Object.keys(tokenMap).find((key) => window.location.href.includes(key));

  if (!urlKey) {
    console.warn('No matching URL found for token assignment');
    return [];
  }

  const token = tokenMap[urlKey];

  const query = `
    {
      metaobjects(type: "locations", first: 200) {
        nodes {
          name: field(key: "name") { value }
          pin: field(key: "pin_code") { value }
          enabled: field(key: "enable_regional_pricing") { value }
        }
      }
    }
  `;

  try {
    const response = await fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();

    const eligiblePins = result.data.metaobjects.nodes
      .filter((n) => n.enabled?.value === 'true')
      .map((n) => n.pin?.value)
      .filter(Boolean);

    console.log('✅ Eligible pins loaded:', eligiblePins);
    return eligiblePins;
  } catch (error) {
    console.error('Error fetching eligible pins:', error);
    return [];
  }
}

async function fetchEligiblePinsCached() {
  console.log('▶️ Entering fetchEligiblePinsCached()');
  const cached = localStorage.getItem('eligiblePins');
  if (cached) return JSON.parse(cached);

  const pins = await fetchEligiblePins();
  localStorage.setItem('eligiblePins', JSON.stringify(pins));
  return pins;
}

let eligiblePins = [];

function initEligiblePins() {
  console.log('🔍 Initializing Eligible Pins fetch');
  fetchEligiblePinsCached().then((pins) => {
    eligiblePins = pins;
    updatePrices();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEligiblePins);
} else {
  initEligiblePins();
}

function fallbackDifferentL2Types(content) {
  if (content && typeof content === 'object' && content.L2) {
    return content.L2;
  }
  return content || {};
}

// Get region
function getRegion() {
  const storedInfo = localStorage.getItem('filteredStoreInfo');
  if (!storedInfo) return 'pa';
  const parsed = JSON.parse(storedInfo);
  return eligiblePins.includes(parsed.storepin) ? 'ohio' : 'pa';
}

// Check if L2 pricing active
function isL2PricingActive(l2Data, ohioPricingBoolean) {
  if (!l2Data || !l2Data.active || !ohioPricingBoolean) return false;
  const now = new Date().toISOString().slice(0, 10);
  return (!l2Data.startDate || now >= l2Data.startDate) && (!l2Data.endDate || now <= l2Data.endDate);
}

// Format price
function formatPrice(price) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
}

// Update prices
async function updatePrices() {
  const region = getRegion();
  if (region !== 'ohio') {
    unhidePrices();
    return;
  }

  setTimeout(() => {
    document.querySelectorAll('.price-item[data-l2]').forEach((el) => {
      const rawL2 = JSON.parse(el.dataset.l2 || '{}');
      const l2Data = fallbackDifferentL2Types(rawL2);
      const ohioPricing = el.dataset.ohioPricing === 'true';
      if (isL2PricingActive(l2Data, ohioPricing)) {
        if (el.innerText.indexOf('was') > -1) {
          el.innerText = 'was ' + formatPrice(l2Data.sellingPrice);
        } else {
          if (el.innerText.indexOf('From') > -1) {
            el.innerText = 'From ' + formatPrice(l2Data.sellingPrice);
          } else {
            el.innerText = formatPrice(l2Data.sellingPrice);
          }
        }

        const compareEl = el.closest('.price').querySelector('s');
        if (compareEl && l2Data.compareAtPrice) {
          compareEl.innerText = formatPrice(l2Data.compareAtPrice);
        }
        if (window.SynchronyWidget) {
          window.SynchronyWidget.update({ price: l2Data.sellingPrice });
        }
      }
    });

    // PLP cards (use .price-item, fetch with try/catch)
    document.querySelectorAll('.price-item[data-l2]').forEach(async (el) => {
      const productHandle = el.closest('.card-wrapper').dataset.productHandle;
      if (!productHandle) return;
      try {
        const response = await fetch(`/products/${productHandle}.json`);
        const data = await response.json();
        const rawL2 = data.product.metafields?.custom.l2 || {};
        const l2Data = fallbackDifferentL2Types(rawL2);
        const ohioPricing = data.product.metafields?.custom.ohio_pricing || false;
        if (isL2PricingActive(l2Data, ohioPricing)) {
          el.innerText = formatPrice(l2Data.sellingPrice);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    });

    // Cart/minicart (use .price--end, no fetch needed)
    document.querySelectorAll('.price--end[data-l2]').forEach((el) => {
      const rawL2 = JSON.parse(el.dataset.l2 || '{}');
      const l2Data = fallbackDifferentL2Types(rawL2);
      const ohioPricing = el.dataset.ohioPricing === 'true';
      if (isL2PricingActive(l2Data, ohioPricing)) {
        const qty =
          el.parentElement.parentElement.parentElement.parentElement.getElementsByClassName('quantity__input')[0].value;
        el.innerText = formatPrice(l2Data.sellingPrice * qty);
      }
    });

    //Update cart totals
    document.querySelectorAll('#cartPriceTarget').forEach((el) => {
      const rawL2 = JSON.parse(el.dataset.totalL2 || '{}');
      el.innerText = formatPrice(rawL2 / 100);
    });

    //update discounts
    const saleDiv = document.querySelector('.price__sale');
    if (saleDiv && saleDiv.textContent.includes('was')) {
      const target = document.querySelector('#pdpPriceTarget');
      if (target && !target.querySelector('span')) {
        const oldPriceElem = document.querySelector('.price-item s');
        if (oldPriceElem) {
          const oldPriceText = oldPriceElem.textContent.trim().replace(/[$,]/g, '');
          const oldPrice = parseFloat(oldPriceText);
          const newPriceText = target.textContent.trim().replace(/[$,]/g, '');
          const newPrice = parseFloat(newPriceText);
          if (!isNaN(oldPrice) && !isNaN(newPrice) && oldPrice > newPrice) {
            const savings = Math.ceil(((oldPrice - newPrice) / oldPrice) * 100);
            const span = document.createElement('span');
            span.textContent = `You save ${savings}%`;
            target.appendChild(document.createTextNode(' '));
            target.appendChild(span);
          }
        }
      }
    }

    document.querySelectorAll('.price-item[data-l2-from]').forEach((el) => {
      if (el.innerText.includes('From') && el.dataset.l2From) {
        const l2FromData = el.dataset.l2From.split('|');
        let minPrice = Infinity;
        let foundValidPrice = false;

        l2FromData.forEach((item) => {
          try {
            const l2Data = JSON.parse(item);
            const data = l2Data.L2 || l2Data;
            if (data.active && data.sellingPrice > 0) {
              if (data.sellingPrice < minPrice) {
                minPrice = data.sellingPrice;
                foundValidPrice = true;
              }
            }
          } catch (e) {
            console.error('Error parsing L2 data item:', item, e);
          }
        });
        if (foundValidPrice) {
          el.innerText = 'From ' + formatPrice(minPrice);
        }
      }
    });

    unhidePrices();
  });
}

function unhidePrices() {
  setTimeout(() => {
    document.querySelectorAll('[p]').forEach((element) => {
      element.removeAttribute('p');
    });

    document.querySelectorAll('[t1]').forEach((element) => {
      element.removeAttribute('t1');
    });
  }, 100);
}

// Set cart attribute
function setCartRegion() {
  const region = getRegion();
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { region, betterlocation: region } }),
  });
  unhidePrices();
}

// Hook into setdefaultData
const originalSetdefaultData = setdefaultData;
setdefaultData = function (element) {
  originalSetdefaultData(element);
  updatePrices();
  setCartRegion();
};

// On load
document.addEventListener('DOMContentLoaded', () => {
  updatePrices();
  setCartRegion();

  setInterval(() => {
    unhidePrices();
  }, 2000);

  const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
  if (variantSelectors.length > 0) {
    variantSelectors.forEach((selector) => {
      selector.addEventListener(
        'change',
        debounce(() => {
          updatePrices();
        }),
      );
    });
  }

  // Fallback for custom Shopify themes that dispatch variant:changed
  document.addEventListener(
    'variant:changed',
    debounce(() => {
      updatePrices();
    }),
  );
});

// On cart update
document.addEventListener('cart:updated', updatePrices);
